var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYolobotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 559.9 559.9",
    style: {
      enableBackground: "new 0 0 559.9 559.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DEFF00;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280,218.5c-32.8,0-61.5,28.2-61.5,61.7s27.3,61.3,61.5,61.3c35.2,0,61.5-27.7,61.5-61.3 S313.2,218.5,280,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M477.5,82.3c52.5,53,80,118.9,82.5,197.6c-2.5,78.7-30,144.6-82.5,197.7c-52.5,53-118.5,80.5-198,82.3 c-78.9-1.9-144.6-29.3-197-82.3C30,424.6,2.5,358.7,0,280c2.5-78.7,30-144.6,82.5-197.6c52.5-53,118.2-80.5,197-82.3 C359,1.9,425,29.3,477.5,82.3z M194.7,365.1c23.6,23.9,51.9,35.8,84.8,35.8c33.5,0,62.1-11.9,85.7-35.8 c23.6-23.9,35.4-52.2,35.4-85.1c0-32.9-11.8-61.2-35.4-85.1C341.6,171,313,159,279.5,159c-32.9,0-61.2,11.9-84.8,35.8 s-35.4,52.2-35.4,85.1C159.3,312.8,171.1,341.2,194.7,365.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYolobotIcon);
export default __webpack_public_path__ + "static/media/yolobot_icon.f5888fc036e4fe833c5b89e92321580e.svg";
export { ForwardRef as ReactComponent };